<script lang="ts">
	import Section from "#lib/web-ui/primitives/section.svelte";
	import {
		Accordion,
		AccordionContent,
		AccordionItem,
		AccordionTrigger
	} from "#lib/web-ui/ui/accordion/index.js";
	import { getTemplateContext } from "../template-context.svelte";

	const templateContext = getTemplateContext();
	const faqItems = [
		{
			question: "What areas do you buy properties in?",
			answer: `We primarily purchase properties in Victoria, TX and the surrounding Crossroads area. Our company started in the crossroads—serving major cities and surrounding areas—and we've expanded our reach throughout the region. We're continually adding new locations, so contact us today if you need to sell your home, commercial property or land quickly.`
		},
		{
			question: "Do I need to make repairs before selling?",
			answer: "No! We buy properties in any condition. You don't need to make any repairs, renovations, or even clean up. We handle everything after purchase."
		},
		{
			question: "How soon can I close if I accept a cash offer?",
			answer: "With our Quick Cash Offer program, we can close in as little as 7 days, though we're flexible and can work with your preferred timeline, up to 30 days or more if needed."
		},
		{
			question: "Are there any fees or commissions on a cash offer?",
			answer: "No. When we make a cash offer, that's the amount you'll receive. There are no commissions, minimal closing costs, and no unexpected fees deducted from our offer."
		},
		{
			question: "Will I need to pay anything upfront for Equity Protection?",
			answer: "No. Our Equity Protection Program requires no upfront costs or out-of-pocket expenses. We only get paid when your property sells successfully."
		},
		{
			question: "How do I know which program is right for my situation?",
			answer: "The Quick Cash Offer is ideal if you need to sell quickly, have a property requiring repairs, or want a hassle-free process. The Equity Protection Program is better if you have more flexibility with time and want to maximize your sale price. We're happy to provide a personalized recommendation during your consultation."
		},
		{
			question: "What if I'm not ready to decide right away?",
			answer: "There's no pressure or obligation. We're happy to make an offer that you can consider on your own timeline, once you've confirmed you're ready to sell. Our team is available to answer any questions you have along the way."
		},
		{
			question: `What should I look for from companies that buy houses in any condition?`,
			answer: `Many businesses claim they'll buy your home in any condition or pay cash, but their efficiency and reliability can vary widely. At ${templateContext.siteName}, we've purchased thousands of homes throughout the crossroads. Our process is designed to make things easy for you, the homeowner, so you can get cash quickly and with minimal hassle.
        
We only make a cash offer if we're confident we can complete the transaction quickly and smoothly. When considering any company, always check their track record and read online reviews. We're proud to have an A+ rating with the Better Business Bureau because of our experience and customer satisfaction. When it comes to selling your biggest asset, trust a company with proven results.`
		},
		{
			question: `Do all companies that buy houses have the same process as ${templateContext.siteName}?`,
			answer: `No, not all buyers follow the same process, and experience levels and procedures can vary widely. Our process is straightforward: After an initial phone call, we'll send one of our qualified team members to visit your property and assess its cash value. We determine that value with you on the spot, so you can make an informed decision—without any pressure. While our program isn't right for everyone, most people find that the simplicity and reduced stress compared to traditional home sales make it an excellent option.`
		}
	];
</script>

<Section class="bg-muted">
	<div class="flex flex-col gap-10 md:flex-row md:gap-16">
		<div class="md:w-1/3">
			<div class="sticky top-20">
				<h2 class="mt-4 text-3xl font-bold">Frequently Asked Questions</h2>
				<p class="text-muted-foreground mt-4 text-lg">
					Common questions <span class="font-medium">{templateContext.siteName}</span>
					hears from homeowners selling a house as-is
				</p>
			</div>
		</div>
		<div class="md:w-2/3">
			<Accordion type="single" class="w-full space-y-2">
				{#each faqItems as item, i}
					<AccordionItem
						value={`item-${i}`}
						class="bg-background rounded-lg border px-4 shadow-xs last:border-b"
					>
						<AccordionTrigger
							class="cursor-pointer items-center py-5 hover:no-underline"
						>
							<div class="flex items-center gap-3">
								<span class="text-base">{item.question}</span>
							</div>
						</AccordionTrigger>
						<AccordionContent class="pb-5">
							<div class="px-9">
								<p class="text-base">{item.answer}</p>
							</div>
						</AccordionContent>
					</AccordionItem>
				{/each}
			</Accordion>
		</div>
	</div>
</Section>
